import "./SearchField.scss";
import { GridCell, GridRow, SearchGlobalField } from "/App.Components";
import { SearchGlobalFieldProps } from "../SearchGlobalField/SearchGlobalField";

const SearchField = (props: SearchGlobalFieldProps) => (
  <div className="search-field-norad">
    <GridRow>
      <GridCell
        startColsDesktop={6}
        spanColsDesktop={12}
        startColsTablet={1}
        spanColsTablet={6}
        startColsMobile={1}
        spanColsMobile={6}
      >
        <SearchGlobalField {...props} />
      </GridCell>
    </GridRow>
  </div>
);

export default SearchField;
